<div class="flex h-full flex-col overflow-auto">
  @if (modalData.accountId && modalData.marketplace) {
    <div class="flex flex-col gap-2 divide-y divide-gray-200">
      @for (asin of usedStrategies() | keyvalue; track asin) {
        <div class="flex gap-4 py-2">
          <app-product-thumbnail
            [asin]="asin.key"
            [marketplace]="modalData!.marketplace"
            [smallImg]="true"
            [withTitle]="true"
          />
          <div class="mt-3 flex flex-col gap-2">
            @for (strategy of asin.value; track strategy) {
              <app-strategy-link [strategyId]="strategy.strategyId!" />
            }
          </div>
        </div>
      }
    </div>
  }
</div>
